var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2364,
    height: 1046,
    transform: "translate(-288 -362)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0045 5.08114L19.2081 10.9229V19.1744H15.6063V15.5233C15.6063 14.0081 14.3907 12.785 12.905 12.785H11.1131C9.61831 12.785 8.41171 14.0172 8.41171 15.5233V19.1744H4.8009V10.9229L12.0045 5.08114ZM12.0045 3C11.8064 3 11.6083 3.06389 11.4462 3.20081L3.34217 9.77282C3.12606 9.94625 3 10.211 3 10.4848V20.0872C3 20.5892 3.4052 21 3.90045 21H9.30315C9.7984 21 10.2036 20.5892 10.2036 20.0872V15.5325C10.2036 15.0304 10.6088 14.6197 11.1041 14.6197H12.8959C13.3912 14.6197 13.7964 15.0304 13.7964 15.5325V20.0872C13.7964 20.5892 14.2016 21 14.6968 21H20.0995C20.5948 21 21 20.5892 21 20.0872V10.4848C21 10.211 20.8739 9.94625 20.6578 9.77282L12.5628 3.20081C12.4007 3.06389 12.2026 3 12.0045 3Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.2b1c8f3ee7c29912f5c3f5a19bc01253.svg";
export { ForwardRef as ReactComponent };